import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { OneColumnSlide } from '../common/OneColumnSlide';
import SlideContent from '../common/SlideContent';
import TaglineCopyTestGrid from './TaglineCopyTestGrid';
export default observer(function TaglineCopyTestEdit({ onMainCTAClick, }) {
    return (_jsx(OneColumnSlide, { children: _jsx(SlideContent, { ctaOnClick: onMainCTAClick, children: _jsx(TaglineCopyTestGrid, {}) }) }));
});
